// JavaScript Document
$(function () {
/*
======================
BODY FADE IN
======================
*/

	setTimeout(function () {
		$("body").removeClass("fade-out");
	}, 320);

	setTimeout(function () {
		$("body").addClass("loaded");
		$("#page-loader").fadeOut(900);
		$(".page-wrap").removeClass("fade-out");
	}, 1200);

/*
===============================
ADDITIONAL BODYCLASSES
===============================
*/

	if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
		$("html").addClass("safari");
	}

	/*
================================
SCROLL ANIMATIONS (WOW JS)
================================
*/

	var wow = new WOW({
		boxClass: "wow",
		animateClass: "animated",
		offset: 0,
		mobile: true,
		live: true,
		scrollContainer: null,
		resetAnimation: false,
	});
	wow.init();

	/*
=========================
OBJECT FIT
=========================
*/

	$(function () {
		objectFitImages("img.object-fit");
	});

	/*
=====================
TEL LINKS
=====================
*/

	//Disable on desktop (non touch)...
	$(".no-touch a.tel").on("click", function (e) {
		e.preventDefault();
	});

	/*
=====================
TABLE WRAPPER
=====================
*/

	$("table").wrap('<div class="table-wrap"></div>');

	/*
======================
IFRAME WRAPPER
======================
*/

	$("section iframe").wrap('<div class="iframe-wrap"></div>');

	/*
===============================
FIXED HEADER
===============================
*/

	let lastScrollTop = 0;

	//add header class
	$(window).on("scroll", function () {
		let scrollTop = $(this).scrollTop();

		// Add "scrolled" class when not at the top
		if (scrollTop > 1) {
			$("#masthead").addClass("scrolled");
		} else {
			$("#masthead").removeClass("scrolled");
		}

		// Determine scroll direction
		if (scrollTop > lastScrollTop) {
			// Scrolling Down
			$("#masthead").removeClass("scrolling-up").addClass("scrolling-down");
		} else if (scrollTop < lastScrollTop) {
			// Scrolling Up
			$("#masthead").removeClass("scrolling-down").addClass("scrolling-up");
		}

		// Remove scrolling direction classes if at the very top
		if (scrollTop === 0) {
			$("#masthead").removeClass("scrolling-up scrolling-down");
		}

		lastScrollTop = scrollTop;
	});

	// On page load, check scroll position
	if ($(window).scrollTop() > 1) {
		$("#masthead").addClass("scrolled");
	}

	/*
======================
HAMBURGER MENU
======================
*/

	//open menu
	$(".menu-toggle").on("click", function () {
		$("body").toggleClass("mobile-navigation--open");
		$(this).toggleClass("active");
		$(".mobile-navigation").toggleClass("active");
	});

	$("#mobile-navigation .menu-item-has-children").append('<div class="menu-expand"><i class="fa-sharp fa-solid fa-chevron-down"></i></div>');

	$(".menu-expand").on("click", function () {
		$(this).toggleClass("active");
		$(this).parent("li").toggleClass("active");
		$(this).parent("li").toggleClass("sub-menu-open");
		$(this).parent("li").find("> ul.sub-menu").slideToggle(600);
	});

	//hover class
	$("#header-navigation ul li")
		.on("mouseenter", function () {
			$(this).addClass("active-hover");
		})
		.on("mouseleave", function () {
			$(this).removeClass("active-hover");
		});

	$(".main-menu .close").on("click", function () {
		console.log('hamburher');
		$(".hamburger").removeClass("active");
		$(".main-menu").removeClass("active");
	});

	/*
================================
MENU AIM
================================
*/

	var $menu = $(".main-menu ul");

	$menu.menuAim({
		activate: activateSubmenu,
		deactivate: deactivateSubmenu,
	});

	function activateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.children("a").addClass("hover");
		$submenu.css({display: "block"});
	}

	function deactivateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.find("a").removeClass("hover");
		$submenu.css("display", "none");
	}

	$(document).click(function () {
		$(".main-menu ul li a.hover").removeClass("hover");
	});

	/*
=======================================
RESPONSIVE DATA TABLES
======================================
*/

	var tables = document.querySelectorAll(".page-section .table-wrap table");
	for (var a = 0; a < tables.length; a++) {
		var headertext = [];
		var headers = tables[a].querySelectorAll("thead td"),
			tablebody = tables[a].querySelector("tbody");

		for (var i = 0; i < headers.length; i++) {
			var current = headers[i];
			headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
		}
		for (var i = 0, row; (row = tablebody.rows[i]); i++) {
			for (var j = 0, col; (col = row.cells[j]); j++) {
				col.setAttribute("data-th", headertext[j]);
			}
		}
	}


	/*
=================================
FANCYBOX
=================================
*/


	$("[data-fancybox]").fancybox({
		autoFocus: false,
		touch: false,
		compact: false,
		beforeShow: function () {
			$("html").addClass("fancybox-opened");
			$("body").css("overflow", "hidden");
		},
		afterClose: function () {
			$("html").removeClass("fancybox-opened");
			$("body").css("overflow", "");
		},
	});

	// Prevent clicking from causing a scroll
	$("[data-fancybox]").on("click", function (e) {
		e.preventDefault();
	});


	/*
======================================
SMOOTH SCROLL
======================================
*/

	//SMOOTH SCROLLING
	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.not('[data-fancybox]')
		.click(function (event) {
			// On-page links
			if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$("html, body").animate(
						{
							scrollTop: target.offset().top - 0,
						},
						1000,
						function () {
							// Callback after animation
							// Must change focus!
						}
					);
				}
			}
		});

	/*
=========================
ACCORDION
=========================
*/
jQuery(function ($) {
    $(".accordion-item .toggle-content").hide();

    $(".accordion-item .toggle-header").on("click", function () {
        var $item    = $(this).closest(".accordion-item");
        var $content = $item.find(".toggle-content").first();
        var $icon    = $(this).find(".toggle-icon");

        // Close others
        $(".accordion-item").not($item).removeClass("active");
        $(".accordion-item .toggle-content").not($content).stop(true, true).slideUp("slow");
        $(".accordion-item .toggle-icon").not($icon).removeClass("rotate-180");

        // Toggle current
        $item.toggleClass("active");
        $icon.toggleClass("rotate-180");
        $content.stop(true, true).slideToggle("slow");
    });
});

	/*
=========================
UP ARROW
=========================
*/

	$(".up").on("click", function (event) {
		event.preventDefault();
		$("body,html").animate({scrollTop: 0}, 1000);
	});

	/*
==========================
BUTTONS
==========================
*/

const bannerContents = document.querySelectorAll('.banner-content');

bannerContents.forEach(content => {
    const buttons = content.querySelectorAll('.button');

    if (buttons.length === 2) {
        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.classList.add('two-buttons');

        // Insert wrapper just before the first button
        buttons[0].parentNode.insertBefore(wrapper, buttons[0]);

        // Move both buttons into the wrapper
        wrapper.appendChild(buttons[0]);
        wrapper.appendChild(buttons[1]);
    }
});


	/*
===========================
MATCH HEIGHTS
===========================
*/

	$(function () {
		$(".news-block h3.block-title").matchHeight({property: "height"});
	});


	/*
==========================
RECAPTCHA FADEOUT
==========================
*/

	$(window).on("scroll", function () {
		var documentHeight = $(document).height();
		var windowHeight = $(window).height();
		var scrollPosition = $(window).scrollTop();

		if (documentHeight - (windowHeight + scrollPosition) < 100) {
			$(".grecaptcha-badge").addClass("fade");
		} else {
			$(".grecaptcha-badge").removeClass("fade");
		}
	});

	/*
==========================
AJAX
==========================
*/

	//LOAD MORE POSTS
	$(".news-posts .posts-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		var loaded = $("input.post-count").val();

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_posts",
				already_loaded: loaded,
			},
			beforeSend: function () {
				$(".news-posts .posts-container .load-more-posts").fadeTo(600, 0, function () {
					$(".news-posts .posts-container .load-more-posts").html('<div class="load"></div>');
				});
				$(".news-posts .posts-container .load-more-posts").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$(".news-posts .posts-container .load-more-posts")
					.delay(1000)
					.fadeOut(700, function () {
						$(".news-posts .posts-container .load-more-posts").remove();
						$(".news-posts .posts-container").append(data);
					});
			},
		});
	});
}); //end document.ready



//update the button styling
function updateButtonStyles(el){
	
	const buttons = el.querySelectorAll('.button');

	if (!buttons) return;

	buttons.forEach(button => {

		if(button.querySelector('.bit-that-lifts-out')){
				return;
		}

		const btnContent = button.innerHTML;

		button.innerHTML = `
		<span class="bit-that-lifts-out">
			<span class="span-for-text-sit-infront-of-z-index">
				{button_content}
			</span>
		</span>
		`.replace('{button_content}', btnContent);
								
	});
}


document.addEventListener('DOMContentLoaded', () => {
  updateButtonStyles(document);
});

//this is needed for the sub-menus with class menu-small so that the whole header 
//can change color when dropping down due to opacity
document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('#site-navigation .level-0');
  const siteHeader = document.querySelector('header');

  if (!menuItems.length || !siteHeader) return;

  menuItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      siteHeader.classList.add('hovering-menu');
    });

    item.addEventListener('mouseleave', () => {
      siteHeader.classList.remove('hovering-menu');
    });
  });
});

//updating the header styles
document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.menu-item-has-children.level-0');
  const siteHeader = document.querySelector('header');

  if (!menuItems.length || !siteHeader) return;

  menuItems.forEach(item => {
    const originalLink = item.querySelector('a');
    const subWrap = item.querySelector('.sub-wrap');
    const subMenu = item.querySelector('.sub-menu');

    if (!originalLink || !subWrap || !subMenu) return;

    // Create a new <a> element
    const newLink = document.createElement('a');
    newLink.href = originalLink.href;
    newLink.textContent = originalLink.textContent;
    newLink.className = 'menu-item-sub-heading';

    // Insert before .sub-menu
    subWrap.insertBefore(newLink, subMenu);
  });
});

//this removes the curves on sections of they are next to one another. 
document.addEventListener('DOMContentLoaded', () => {
	const sections = document.querySelectorAll('section');

	sections.forEach(section => {
		const sectionIsBanner = section.classList.contains('image-banner');

		const prev = section.previousElementSibling;
		const next = section.nextElementSibling;

		const prevHasBg = prev && prev.classList.contains('section-has-bg');
		const nextHasBg = next && next.classList.contains('section-has-bg');

		if (sectionIsBanner && nextHasBg) {
			const bannerImage = section.querySelector('.bg-banner-image');

			if (bannerImage) {
				bannerImage.classList.remove('mask-box-bottom');
			}
		}

		const startedWithTop = section.classList.contains('mask-box-top');
		const startedWithBottom = section.classList.contains('mask-box-bottom');
		const startedWithBoth = section.classList.contains('mask-box-both');

		let needsTopMask = startedWithTop || startedWithBoth;
		let needsBottomMask = startedWithBottom || startedWithBoth;

		if (prevHasBg) {
			needsTopMask = false;
		}

		if (nextHasBg) {
			needsBottomMask = false;
		}

		section.classList.remove('mask-box-top', 'mask-box-bottom', 'mask-box-both');

		if (needsTopMask && needsBottomMask) {
			section.classList.add('mask-box-both');
		} else if (needsTopMask) {
			section.classList.add('mask-box-top');
		} else if (needsBottomMask) {
			section.classList.add('mask-box-bottom');
		}
	});
});

//change the padding on certain sections if they are next to another
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.materials-section');
	console.log('sections found:', sections);
  sections.forEach(section => {
	const hasClassTop = section.classList.contains('mask-box-top')
	console.log('hasClassTop:', hasClassTop);
	const next = section.nextElementSibling;
	const nextSectionIsIndustries = next && next.classList.contains('industries-section');
	console.log('nextSectionIsIndustries:', nextSectionIsIndustries);
	if(hasClassTop && nextSectionIsIndustries){
		//alter the padding of both sections.
		section.classList.add('pb-curve-section-lg');
		next.classList.add('pt-curve-section-lg');
	}
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const subMenus = document.querySelectorAll('.mobile-navigation .sub-menu');

  subMenus.forEach(menu => {
	const hideTextLi = menu.querySelectorAll('.hide-text');
	if(hideTextLi.length === 0) return;

	hideTextLi.forEach(li => {
		const parentNode = li.parentNode;
		const children = li.querySelectorAll('li');
		children.forEach(child => {
			child.classList.remove('level-2');
			child.classList.add('level-1');
		});
		parentNode.append(...children);
		parentNode.removeChild(li);
	});
  });
});

// document.addEventListener('DOMContentLoaded', () => {
// 	  const topSection = document.querySelector('#section-0');
// 	  const banner = document.querySelector('.image-banner');
// 	  if (!topSection || !banner) return;
// 	  topSection.classList.add('move-section-up-class');
// });















(function(){
  const thumbs = new Swiper(".thumbsSwiper", {
    direction: window.matchMedia("(max-width: 1024px)").matches ? "horizontal" : "vertical",
    slidesPerView: 5,
    spaceBetween: 12,
    freeMode: true,
    watchSlidesProgress: true,
    mousewheel: true,
    breakpoints: {
      0:    { direction: "horizontal", slidesPerView: 4, spaceBetween: 8  },
      640:  { direction: "horizontal", slidesPerView: 6, spaceBetween: 10 },
      1024: { direction: "vertical",   slidesPerView: 5, spaceBetween: 20 }
    }
  });

  const main = new Swiper(".mainSwiper", {
    spaceBetween: 10,
    speed: 500,
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    pagination: { el: ".swiper-pagination", clickable: true },
    thumbs: { swiper: thumbs }
  });

  // Keep thumbs orientation synced on resize
  const mql = window.matchMedia("(max-width: 1024px)");
  const updateDir = () => {
    const want = mql.matches ? "horizontal" : "vertical";
    if (thumbs.params.direction !== want){
      thumbs.changeDirection(want);
      thumbs.update();
    }
  };
  mql.addEventListener ? mql.addEventListener("change", updateDir) : mql.addListener(updateDir);
})();






    //this is for the 3 col icon slider
    $(".swiper-wrap").each(function (index, element) {
		var $this = $(element);

		// Find elements inside this swiper-wrap only
		var swiperEl     = $this.find(".swiper")[0];
		var nextBtn      = $this.find(".swiper-button-next")[0];
		var prevBtn      = $this.find(".swiper-button-prev")[0];
		var paginationEl = $this.find(".swiper-pag")[0];

		// Create a new swiper tied to this wrapper
		new Swiper(swiperEl, {
			slidesPerView: 1.3,
			autoplay: false,
			loop: false,
			spaceBetween: 30,
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
			},
			pagination: {
				el: paginationEl,
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
			},
		});
	});







(function () {
  const wraps = document.querySelectorAll('.svc-swiper-wrap');
  if (!wraps.length) return;

  wraps.forEach((wrap) => {
    const swiperEl = wrap.querySelector('.svc-swiper');
    if (!swiperEl) return;

    const swiper = new Swiper(swiperEl, {
      initialSlide: 1, // start on the 2nd slide
      loop: false,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 3,
      grabCursor: true,
      navigation: {
        nextEl: wrap.querySelector('.svc-swiper-next'),
        prevEl: wrap.querySelector('.svc-swiper-prev'),
      },
      pagination: {
        el: wrap.querySelector('.svc-swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        640:  { spaceBetween: 20 },
        768:  { spaceBetween: 24 },
        1024: {  spaceBetween: 24 },
      },
      on: {
        init(s) {
          // Ensure it lands on slide 1 even if widths/layout shift on first paint
          s.slideTo(1, 0, false);
        }
      }
    });
  });
})();









(function () {
  const wraps = document.querySelectorAll('.svc-swiper-wrap-logo');
  if (!wraps.length) return;

  wraps.forEach((wrap) => {
    const swiperEl = wrap.querySelector('.svc-swiper-logo');
    if (!swiperEl) return;

    const swiper = new Swiper(swiperEl, {
      initialSlide:1, // start on the 2nd slide
      loop: false,
      centeredSlides: true,
      slidesPerView: 2,
      spaceBetween: 3,
      grabCursor: true,
      navigation: {
        nextEl: wrap.querySelector('.svc-swiper-next-logo'),
        prevEl: wrap.querySelector('.svc-swiper-prev-logo'),
      },
      pagination: {
        el: wrap.querySelector('.svc-swiper-pagination-logo'),
        clickable: true,
      },
      breakpoints: {
        640:  { spaceBetween: 10, slidesPerView: 2, },
        768:  { spaceBetween: 10, slidesPerView: 3, },
        1024: {  spaceBetween: 10, slidesPerView: 4,  },
      },
      on: {
        init(s) {
          // Ensure it lands on slide 1 even if widths/layout shift on first paint
          s.slideTo(1, 0, false);
        }
      }
    });
  });
})();